import { Locale } from '@ps-smart-cp/ppfw-client';

const appxTgtClassNameConfig = {
  unspecified: new Map([
    [Locale.ja, '指定なし'],
    [Locale.en, 'Unspecified'],
  ]),
  appxSixteenOneTgtAsset: new Map([
    [Locale.ja, '別表十六(一)対象資産'],
    [Locale.en, 'Appendix Sixteen One Target Asset'],
  ]),
  appxSixteenTwoTgtAsset: new Map([
    [Locale.ja, '別表十六(二)対象資産'],
    [Locale.en, 'Appendix Sixteen Two Target Asset'],
  ]),
  appxSixteenUpperTgtAsset: new Map([
    [Locale.ja, '別表十六(六)・上段対象資産'],
    [Locale.en, 'Appendix Sixteen Upper Target Asset'],
  ]),
  appxSixteenLowerTgtAsset: new Map([
    [Locale.ja, '別表十六(六)・下段対象資産'],
    [Locale.en, 'Appendix Sixteen Lower Target Asset'],
  ]),
} satisfies Record<string, Map<Locale, string>>;

export { appxTgtClassNameConfig };
